import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Schedule, ScheduleDynamic } from '../models/index';

@Injectable({
  providedIn: 'root'
})
/**
 * Service to managment the schedule by services to connect to backend
 */
export class ScheduleService {

  /**
   * For schedule between create / edit / view with table of schedule
   */
  public readonly arrayScheduleSubject: BehaviorSubject<ScheduleDynamic[]> = new BehaviorSubject<ScheduleDynamic[]>([]);

  public setArraySchedule(arraySchedule: ScheduleDynamic[]): void {
    this.arrayScheduleSubject.next(arraySchedule);
  }

  public get arrayScheduleAction$(): Observable<ScheduleDynamic[]> {
    return this.arrayScheduleSubject.asObservable();
  }

  constructor(
    private readonly http: HttpClient
  ) { }

  /**
   * Create a new schedule for module CAE
   * @param schedule Schedule to create
   * @returns 
   */
  public createSchedule(schedule: Schedule): Observable<any> {
    return this.http.post<any>(`/assistance/group/schedule`, schedule);
  }

  /**
   * Edit a schedule of module CAE
   * @param schedule Schedule to edit
   * @returns 
   */
  public editSchedule(schedule: Schedule): Observable<any> {
    return this.http.put<any>(`/assistance/group/schedule`, schedule);
  }

  /**
   * Enabled or disabled any schedule of module CAE
   * @param schedule Schedule to enabled or disabled
   * @returns 
   */
  public enabledSchedule(idSchedule: string, enabled: boolean): Observable<any> {
    const build = {
      id: idSchedule,
      enabled: enabled
    }
    const body = JSON.stringify(build);
    return this.http.post<any>(`/assistance/group/schedule/enable`, body);
  }

  /**
   * SERVICES TO INTERNAL LOGIC FRONT
   */

  /**
   * Get a list of hours, since 00:00 to 23:59, every minutes set
   * @param minutes The minutes the array will traverse until the end time (15, 30, 45, 60, etc.)
   * @returns 
   */
  public getListHours(minutes: number): string[] {
    const hours: string[] = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += minutes) {//change 30 for desired minutes like 15, 30, 45, 60
        const formattedHour = hour.toString().padStart(2, '0');
        const formattedMinute = minute.toString().padStart(2, '0');

        hours.push(`${formattedHour}:${formattedMinute}`);
      }
    }
    hours.push("23:59");
    return hours;
  }


  public getListHoursTolerance(inicio: string, fin: string, intervalo: number = 5): string[] {
    // Validar formato de entrada
    if (!/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/.test(inicio) || !/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/.test(fin)) {
      throw new Error('Formato de hora inválido. Debe ser HH:MM');
    }

    // Convertir horas a minutos para facilitar los cálculos
    const inicioMinutos = parseInt(inicio.split(':')[0]) * 60 + parseInt(inicio.split(':')[1]);
    const finMinutos = parseInt(fin.split(':')[0]) * 60 + parseInt(fin.split(':')[1]);

    // Crear el arreglo de horarios
    const horarios: string[] = [];
    for (let minutos = inicioMinutos; minutos <= finMinutos; minutos += intervalo) {
      const horas = Math.floor(minutos / 60).toString().padStart(2, '0');
      const minutosStr = (minutos % 60).toString().padStart(2, '0');
      horarios.push(`${horas}:${minutosStr}`);
    }

    return horarios;
  }

}
